import { FC } from 'react';

import { LegalClientVersionEntity } from 'api/types/entity';
import { NavigationBreadcrumbsTitles } from 'components';
import { LayoutWithNavigationBreadcrumbs } from 'components/LayoutWithNavigationBreadcrumbs';
import { Form } from 'libs/form/Form';
import { getVersionDate } from 'modules/client/common/helpers';
import { VersionView } from 'modules/client/common/views';

import {
  LegalClientBeneficiarySections,
  LegalClientBeneficiarySectionsProps,
} from '../components';
import { LegalClientBeneficiaryFormType } from '../forms/legalClientBeneficiaryForm';

export interface LegalClientBeneficiaryVersionViewProps
  extends LegalClientBeneficiarySectionsProps {
  breadcrumbsTitles: NavigationBreadcrumbsTitles;
  versions: LegalClientVersionEntity[];
  initialValues?: LegalClientBeneficiaryFormType;
  fullName: string;
  versionId: string;
  error?: string;
  snapshotLoading?: boolean;
  onChangeVersion: (version: LegalClientVersionEntity) => void;
  onCloseVersionHistory: () => void;
}

export const LegalClientBeneficiaryVersionView: FC<
  LegalClientBeneficiaryVersionViewProps
> = ({
  breadcrumbsTitles,
  versions,
  fullName,
  initialValues,
  snapshotLoading,
  versionId,
  error,
  onCloseVersionHistory,
  onChangeVersion,
  ...sectionsProps
}) => (
  <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
    <VersionView
      content={
        initialValues && (
          <Form
            initialReadOnly
            initialShowCopyButton
            initialValues={initialValues}
            onSubmit={() => {}}
          >
            <LegalClientBeneficiarySections
              hideActivitySection
              countryRiskAt={getVersionDate(versions, versionId)}
              {...sectionsProps}
            />
          </Form>
        )
      }
      error={error}
      loading={snapshotLoading}
      name={fullName}
      versionId={versionId}
      versions={versions}
      onChangeVersion={onChangeVersion}
      onCloseVersionHistory={onCloseVersionHistory}
    />
  </LayoutWithNavigationBreadcrumbs>
);
